import LayersPass from './layers-pass';
import { withParameters } from '@luma.gl/core';
const PICKING_PARAMETERS = {
  blendFunc: [1, 0, 32771, 0],
  blendEquation: 32774
};
export default class PickLayersPass extends LayersPass {
  render(props) {
    if (props.pickingFBO) {
      this.useAlpha = true;

      this._drawPickingBuffer(props);
    } else {
      this.useAlpha = false;
      super.render(props);
    }
  }

  _drawPickingBuffer({
    layers,
    layerFilter,
    views,
    viewports,
    onViewportActive,
    pickingFBO,
    deviceRect: {
      x,
      y,
      width,
      height
    },
    pass = 'picking',
    redrawReason,
    pickZ
  }) {
    const gl = this.gl;
    this.pickZ = pickZ;
    return withParameters(gl, {
      scissorTest: true,
      scissor: [x, y, width, height],
      clearColor: [0, 0, 0, 0],
      depthMask: true,
      depthTest: true,
      depthRange: [0, 1],
      colorMask: [true, true, true, true],
      ...PICKING_PARAMETERS,
      blend: !pickZ
    }, () => {
      super.render({
        target: pickingFBO,
        layers,
        layerFilter,
        views,
        viewports,
        onViewportActive,
        pass,
        redrawReason
      });
    });
  }

  shouldDrawLayer(layer) {
    return layer.props.pickable;
  }

  getModuleParameters() {
    return {
      pickingActive: 1,
      pickingAttribute: this.pickZ,
      lightSources: {}
    };
  }

  getLayerParameters(layer, layerIndex) {
    const pickParameters = this.pickZ ? {
      blend: false
    } : { ...PICKING_PARAMETERS,
      blend: true,
      blendColor: [0, 0, 0, this.useAlpha ? (layerIndex + 1) / 255 : 1]
    };
    return { ...layer.props.parameters,
      ...pickParameters
    };
  }

}
//# sourceMappingURL=pick-layers-pass.js.map